import React from "react";

const Loader = () => {
  return (
    <div
      className="flex items-center justify-center min-h-screen cw-bg"
    >
      <div className="flex flex-col items-center gap-5 animate-fade-in">
        {/* Spinner rings */}
        <div className="relative w-14 h-14">
          <span className="absolute inset-0 rounded-full border-4 border-blue-500/15" />
          <span className="absolute inset-0 rounded-full border-4 border-t-blue-500 border-r-transparent border-b-transparent border-l-transparent animate-spin" />
          <span
            className="absolute inset-2 rounded-full border-2 border-t-purple-500 border-r-transparent border-b-transparent border-l-transparent animate-spin"
            style={{ animationDirection: "reverse", animationDuration: "0.7s" }}
          />
          <span className="absolute inset-0 m-auto w-3 h-3 rounded-full bg-blue-500 opacity-80 animate-pulse" />
        </div>

        {/* Label */}
        <div className="text-center">
          <p className="cw-text-muted text-sm font-medium tracking-wide animate-pulse">
            Loading…
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
